import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';

const marksLambda = [
  { value: 0, label: '0' },
  { value: 14, label: '0.001' },
  { value: 28, label: '0.01' },
  { value: 43, label: '0.1' },
  { value: 57, label: '1' },
  { value: 71, label: '10' },
  { value: 86, label: '100' },
  { value: 100, label: '1000' },
];

const minDistance = 14;

export default function DiscreteSliderMarks2({setLambdaSliderValue, compareColour, sliderTitle}) {


    const wrapperStyle = { width: 400, margin: 50 };

    const [value, setValue] = React.useState([0, 100]);
    var lambdaValue = [0,0]
    const handleChange = (event, newValue, activeThumb) => {

        setValue(newValue);
        if(newValue[0] > 100){
            newValue[0]= 100;
            setValue(newValue)
        }
        if (activeThumb === 0) {
            setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
            newValue=[Math.min(newValue[0], value[1] - minDistance), value[1]]

          } else {
            setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
            newValue=[value[0], Math.max(newValue[1], value[0] + minDistance)]

          }
      
        lambdaValue = newValue
        switch (lambdaValue[0]) {
            case 0:  lambdaValue[0] = 0;
                     break;
            case 14:  lambdaValue[0] = .001;
                     break;
            case 28:  lambdaValue[0] = .01;
                     break;
            case 43:  lambdaValue[0] = .1;
                     break;
            case 57:  lambdaValue[0] = 1;
                     break;
            case 71:  lambdaValue[0] = 10;
                     break;
            case 86:  lambdaValue[0] = 100;
                     break;
            case 100:  lambdaValue[0] = 1000;
                     break;
        }

        switch (lambdaValue[1]) {
            case 0:  lambdaValue[1] = 0;
                     break;
            case 14:  lambdaValue[1] = .001;
                     break;
            case 28:  lambdaValue[1] = .01;
                     break;
            case 43:  lambdaValue[1] = .1;
                     break;
            case 57:  lambdaValue[1] = 1;
                     break;
            case 71:  lambdaValue[1] = 10;
                     break;
            case 86:  lambdaValue[1] = 100;
                     break;
            case 100:  lambdaValue[1] = 1000;
                     break;
        }
    
        setLambdaSliderValue(lambdaValue);
      };
    
      return (
        <div style={wrapperStyle}>
          <h3 className="widgetLgTitle">{ sliderTitle} <Tooltip title="The range of lambda values to run the experiment on.">
        <InfoIcon color='primary' > </InfoIcon>
</Tooltip></h3>
        <Box sx={{ width: 500 }}>
          <Slider
            aria-label="Custom marks"
            value={value}
            defaultValue={43}
            step={null}
            marks={marksLambda}
            onChange={handleChange}
            disableSwap
            color={compareColour}
          />
        </Box>
        </div>
      )
}













